export const API_URLS = {
  getStatistic: '/api/get_statistics',
  getTrafficDetail: '/api/v2/get_traffic_detail',
  getPaymentDocuments: '/api/get_documents',
  getAvailableTrafficPacks: '/api/get_available_traffic_packs',
  getTrafficPacksHistory: '/api/v2/get_traffic_packs_history',
  getActivePack: '/api/get_active_packs_info',
  getContractData: '/api/get_contract_data',
  authlog: '/api/authlog',
  logout: '/api/logout',
  getAssistPaymentInfo: '/api/v2/get_assist_payment_info',
  printDocument: '/api/print_document',
  changePassword: '/api/change_password',
  supportRequest: '/api/support_request',
  getTrafficPackExpireInfo: '/api/get_traffic_pack_expire_info',
  getBlockingApplication: '/api/get_blocking_application',
  sendBlockingApplication: '/api/send_blocking_application',
};
